// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-trend-down';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.424 8.496v5.04h-5.04' />
    <path d='M17.424 13.536 11.448 7.56a1.13 1.13 0 0 0-1.584 0L7.488 9.936a1.13 1.13 0 0 1-1.584 0L.576 4.464' />
  </g>
);

export const viewBox = '0 0 18 18';
